import { Col } from 'react-styled-flexboxgrid';
import styled, { css } from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../../theme/helpers/fontStyle';

import { getBorderRadius } from './FileUpload.helpers';

interface IconContainerProps {
  $isDragActive: boolean;
  $isDisabled?: boolean;
}

interface DropzoneProps {
  $isDragActive: boolean;
  $isDisabled?: boolean;
  $isError?: boolean;
}

export const $FileInput = styled.input`
  display: none;
`;

const iconContainerHoverMixin = css<DropzoneProps>`
  > svg {
    opacity: 1;
    transform: translate(-50%, -50%) scale3d(1, 1, 1);
    color: ${({ theme }) => theme.colors.mainTextColor};
  }
`;

export const $IconContainer = styled.div<IconContainerProps>`
  position: relative;
  > svg {
    width: ${spacing(16)};
    height: ${spacing(16)};
    position: absolute;
    opacity: 0;

    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale3d(0.8, 0.8, 0.8);
    pointer-events: none;
    transition-duration: 0.3s;
  }

  ${({ $isDragActive }) => {
    return $isDragActive ? iconContainerHoverMixin : null;
  }};

  &:hover {
    ${iconContainerHoverMixin};
  }
`;

const dropZoneHoverMixin = css<DropzoneProps>`
  border-color: ${({ theme, $isDisabled, $isError }) => {
    return $isDisabled || $isError ? undefined : theme.colors.primary;
  }};
  p {
    filter: ${({ $isDisabled }) => ($isDisabled ? undefined : 'blur(2px)')};
  }
`;

export const $Dropzone = styled.button<DropzoneProps>`
  border: 1px solid
    ${({ theme, $isError }) => {
      if ($isError) {
        return theme.colors.danger;
      }

      return theme.colors.default;
    }};
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : undefined)};

  height: ${spacing(40)};
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${({ theme, $isDisabled }) =>
    $isDisabled
      ? theme.colors.disabled
      : theme.systemColors.secondaryBackground};
  border-radius: ${getBorderRadius};

  filter: ${({ $isDisabled }) => ($isDisabled ? `blur(2px)` : undefined)};

  transition-duration: 0.3s;

  p {
    color: ${({ theme }) => theme.colors.mainTextColor};
    ${fontStyle('sm')};
    transition-duration: 0.3s;
  }

  ${({ $isDragActive }) => ($isDragActive ? dropZoneHoverMixin : null)};
  &:hover {
    ${dropZoneHoverMixin};
  }
`;

export const $Col = styled(Col)<{ $dropzone?: boolean }>`
  && {
    flex: ${({ $dropzone }) => ($dropzone ? null : 0)};
    margin-bottom: ${spacing('lg')};
  }
`;
